import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { dealjacketActions, orgActions } from "../../actions";


function DoctypeModal(props) {
  const { authentication, org, closeModal, item, getDocTypes, editDealJacket} = props;

  const org_id = org?.current_org_id;
  const user_doctypes = authentication?.user?.doctypes?.filter((doctype) => doctype.org_id === org.current_org_id);
  const user_orgs = authentication.user.orgs;
  const org_doctypes = org?.doc_types;
  const doctypes = (user_doctypes?.length > 0)? user_doctypes?.map((doctype) => doctype.doc_type_name) : org_doctypes?.map((doctype) => doctype.doc_type);
  

  const current_org = user_orgs.filter(
    (org) => org.org_id === org_id
  )[0];

  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;

  const [selectedDocType, setSelectedDocType] = useState("");

  useEffect(() => {
    getDocTypes(current_org?.org_id);
  }, [])

  useEffect(() => {
    if (item) {
      setSelectedDocType(item.doc_type);
    }
  }, [item])

  const onChangeDocType = (e) => {
    setSelectedDocType(e.target.value);
}

  const handleSubmit = () => {
    let input = {};
    Object.assign(input, item);
    input["org_id"] = Number(org_id);
    input["doc_type"] = selectedDocType;
    editDealJacket(input);
    closeModal();
  }

  const doctypes_html = doctypes?.map((doctype, i) => (
    <>
        <option key={doctype} id="doctype" name="doctypes" value={doctype}>
          {doctype}
        </option>
    </>
  ));

  return (
    <div>
      <h4>
        <span style={{ fontSize: "0.6em" }}>change doctype for</span>
        &nbsp;&nbsp;

        <span className="doctypeModalFileName">{item.deal_jacket_name}
        </span>&nbsp;&nbsp;&nbsp;&nbsp;


        <div className="editJacketNameIcon" onClick={closeModal} data-tip data-for="cancel">
          <img src={cancelicon} style={{ verticalAlign: "middle" }} width="20px" alt="cancel" />
        </div>

        &nbsp;&nbsp;&nbsp;
        <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
          cancel
        </ReactTooltip>

        <div className="editJacketNameIcon" data-tip data-for="save" >
          <img src={saveicon} style={{ verticalAlign: "middle" }} width="20px" alt="save" onClick={handleSubmit} />
        </div>


        <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
          save
        </ReactTooltip>
      </h4>
      <hr/>
      <br/>
      <select className="orgDropdown"
            value={selectedDocType?selectedDocType:"select a doc type"}
            onChange = {(e) => onChangeDocType(e)}
        >
        {doctypes_html}
        </select>



    </div>
  )

}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  editDealJacket: dealjacketActions.editDealJacket
};

const connectedDoctypeModal = connect(mapStateToProps, actionCreators)(DoctypeModal);
export { connectedDoctypeModal as DoctypeModal };